import graphql from 'babel-plugin-relay/macro';
import { commitMutation } from 'react-relay';
import AbEnvironment from '../auth/AbEnvironment'; 
  
  const abEnvironment = new AbEnvironment();
  const mutation = graphql`
  mutation PaymentSourceCreateMutation($input: CreatePaymentSourceTInput!) {
    createPaymentSourceT(input: $input) {
      paymentSourceT {
        psId
        accountId
        psType
        psStatus
        psOrder
        psStatusIn
        psOrderIn
        lastName
        firstName
        email
        phone
        address1
        address2
        city
        state
        country
        postalCode
        ccBrand
        ccLast4
        ccExpy
        extSource
        extPsId
        paypalEmail
      }
    }
  }
  `;
    
  function commit(accountId, psType, psStatus, psOrder, psStatusIn, psOrderIn,
                  lastName, firstName, email, phone,
                  address1, address2, city, state, country, postalCode,
                  ccBrand, ccLast4, ccExpy,
                  extSource, extPsId, paypalEmail) {
    const variables = {
      input: {
        paymentSourceT: {
          accountId,
          psType,
          psStatus,
          psOrder,
          psStatusIn,
          psOrderIn,
          lastName,
          firstName,
          email,
          phone,
          address1,
          address2,
          city,
          state,
          country,
          postalCode,
          ccBrand,
          ccLast4,
          ccExpy,
          extSource,
          extPsId,
          paypalEmail
        }
      }
    }
    
    return new Promise((resolve, reject) => {
      commitMutation(
        abEnvironment.getEnvironment(), {
          mutation,
          variables,
          onCompleted: (response) => {
            resolve(response);
          },
          onError: (error) => {
            reject(error);
          }
      });
    });
  }
  /* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
  export default { commit };
  